import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
} from "reactstrap";
import PropertyForm from "../PropertyForm"
import CompoundService from "services/Admin/CompoundService"
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import { adminPrefix } from "configs/routePrefix";

const EditProperty = (props) => {
    const id = props.match.params.id

    return (
        <>
            <div className='page-content'>
                <MetaTags>
                    <title>Property</title>
                </MetaTags>
                <Container fluid>
                    <Row>
                        <h4>Edit Property</h4>
                    </Row>
                    <PropertyForm id={id} history={props.history} />

                </Container>
            </div>
        </>
    )
}

export default EditProperty